module.exports = "/images/miniature.jpg?399455d2cd36df7fc4c65768c71b54f2";


//////////////////
// WEBPACK FOOTER
// ./resources/images/miniature.jpg
// module id = Zjzj
// module chunks = 0